<template>
  <div>
    <!-- <Map :options="{url:'/api/admin/map', mode:'public'}" /> -->
    <MapOnline
      v-if="contentLoaded"
      :map-markers="mapMarkers"
      :options="{mode:'user'}"
    />
  </div>
</template>

<script>
import MapMarker from '@/vuex/orm/models/MapMarker';

export default {
  name: 'PageMap', // important

  components: {
    MapOnline: () => import('@/components/map/MapOnline'),
  },

  data() {
    return {
      contentLoaded: false,
      mapMarkers: [],
    };
  },

  created() {
    this.loadMapMarkers();
  },

  mounted() {
    Bus.$on('map-markers:loaded', () => {
      this.loadMapMarkers();
    });

    Bus.$on('map-markers:refreshed', () => {
      this.loadMapMarkers();
    });
  },

  activated() {
    console.log('activated');
  },
  deactivated() {
    console.log('deactivated');
  },

  beforeDestroy() {
    Bus.$off('map-markers:loaded');
    Bus.$off('map-markers:refreshed');
  },

  methods: {
    loadMapMarkers() {
      this.mapMarkers = MapMarker.query().get();

      console.log('map-markers.count', this.mapMarkers.length);

      if (this.mapMarkers.length) {
        this.contentLoaded = true;
      }
    },
  },
};
</script>
